/**
 * CASEMIRA - Variant Drawer V12
 * Base sur V8 qui fonctionnait + ameliorations
 * - Detection des options corrigee
 * - Clic dehors ferme le drawer
 * - Style theme Hyper
 */

(function () {
  'use strict';

  function normalize(s) {
    return (s || '').toString().trim().toLowerCase();
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
      cents = parseInt(cents, 10);
    }
    if (window.FoxTheme && window.FoxTheme.Currency && window.FoxTheme.Currency.formatMoney) {
      return window.FoxTheme.Currency.formatMoney(cents, format);
    }
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, format);
    }
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return euros + '\u20AC';
  }

  function findOptionIndex(productJson, names) {
    if (!productJson || !productJson.options || !productJson.options.length) return -1;
    var wanted = names.map(normalize);
    return productJson.options.findIndex(function(opt) {
      var optLower = normalize(opt);
      return wanted.some(function(w) {
        return optLower === w || optLower.indexOf(w) !== -1;
      });
    });
  }

  // SVG FORMES
  var SHAPE_SVGS = {
    rectangulaire: '<svg viewBox="0 0 44 30" fill="none"><rect x="2" y="5" width="40" height="20" rx="2" fill="#c4c4c4"/></svg>',
    carre: '<svg viewBox="0 0 36 36" fill="none"><rect x="3" y="3" width="30" height="30" rx="2" fill="#c4c4c4"/></svg>',
    ovale: '<svg viewBox="0 0 44 30" fill="none"><ellipse cx="22" cy="15" rx="20" ry="12" fill="#c4c4c4"/></svg>',
    rond: '<svg viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="15" fill="#c4c4c4"/></svg>',
    couloir: '<svg viewBox="0 0 56 24" fill="none"><rect x="2" y="6" width="52" height="12" rx="2" fill="#c4c4c4"/></svg>',
    default: '<svg viewBox="0 0 44 30" fill="none"><rect x="2" y="5" width="40" height="20" rx="2" fill="#c4c4c4"/></svg>'
  };

  function getShapeSVG(shapeName) {
    var name = normalize(shapeName);
    if (name.indexOf('rect') !== -1) return SHAPE_SVGS.rectangulaire;
    if (name.indexOf('carr') !== -1 || name.indexOf('square') !== -1) return SHAPE_SVGS.carre;
    if (name.indexOf('oval') !== -1) return SHAPE_SVGS.ovale;
    if (name.indexOf('rond') !== -1 || name.indexOf('circle') !== -1 || name.indexOf('round') !== -1) return SHAPE_SVGS.rond;
    if (name.indexOf('couloir') !== -1 || name.indexOf('runner') !== -1) return SHAPE_SVGS.couloir;
    return SHAPE_SVGS.default;
  }

  function getSelectedOptionsFromForm(productJson, context) {
    var selected = [];
    var root = context || document;
    productJson.options.forEach(function(optionName) {
      var checkedRadio = root.querySelector('input[type="radio"][data-option-name="' + optionName + '"]:checked');
      if (checkedRadio) { selected.push(checkedRadio.value); return; }
      var fieldset = root.querySelector('fieldset[data-option-name="' + optionName + '"]');
      if (fieldset) {
        var checkedInput = fieldset.querySelector('input[type="radio"]:checked');
        if (checkedInput) { selected.push(checkedInput.value); return; }
      }
      selected.push('');
    });
    return selected;
  }

  function setOptionValueInForm(productJson, optionIndex, value, context) {
    var optionName = productJson.options[optionIndex];
    if (!optionName) return false;
    var root = context || document;
    var escapedValue = CSS.escape(value);
    var radio = root.querySelector('input[type="radio"][data-option-name="' + optionName + '"][value="' + escapedValue + '"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  function findVariantByOptions(productJson, selectedOptions) {
    return productJson.variants.find(function(v) {
      return v.options.every(function(opt, i) {
        return normalize(opt) === normalize(selectedOptions[i]);
      });
    });
  }

  function getDiscountPercent(price, compareAt) {
    if (!compareAt || compareAt <= price) return 0;
    return Math.round(((compareAt - price) / compareAt) * 100);
  }

  // ETAT
  var state = {
    isOpen: false,
    overlay: null,
    drawer: null,
    productJson: null,
    optShape: -1,
    optSize: -1,
    moneyFormat: '{{amount}}\u20AC',
    isAddingToCart: false,
    summaryEl: null,
    formContext: null,
    dragStartY: 0,
    currentTranslate: 0,
    isDragging: false
  };

  function openDrawer() {
    if (state.isOpen) return;
    state.isOpen = true;
    state.overlay.classList.add('is-visible');
    state.drawer.classList.add('is-visible');
    state.drawer.style.transform = '';
    state.currentTranslate = 0;
  }

  function closeDrawer() {
    if (!state.isOpen) return;
    state.isOpen = false;
    state.overlay.classList.remove('is-visible');
    state.drawer.classList.remove('is-visible');
    state.drawer.style.transform = '';
  }

  function createDrawer() {
    if (state.drawer) return;

    var oldOverlay = document.getElementById('vd-overlay');
    var oldDrawer = document.getElementById('vd-drawer');
    if (oldOverlay) oldOverlay.remove();
    if (oldDrawer) oldDrawer.remove();

    var overlay = document.createElement('div');
    overlay.id = 'vd-overlay';
    overlay.className = 'vd-overlay';

    var drawer = document.createElement('div');
    drawer.id = 'vd-drawer';
    drawer.className = 'vd-drawer';

    drawer.innerHTML = '<div class="vd-drawer__handle" data-handle><span></span></div>' +
      '<div class="vd-drawer__header">' +
        '<h2 class="vd-drawer__title">Choisir la forme</h2>' +
        '<button type="button" class="vd-drawer__close" aria-label="Fermer">' +
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 24 24">' +
            '<path d="M18.75 5.13496L5.25 18.8544" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
            '<path d="M18.75 18.8544L5.25 5.13504" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
          '</svg>' +
        '</button>' +
      '</div>' +
      '<div class="vd-drawer__body">' +
        '<div class="vd-drawer__shapes" data-shapes-section>' +
          '<div class="vd-drawer__shapes-grid" data-shapes></div>' +
        '</div>' +
        '<div class="vd-drawer__sizes-section" data-sizes-section>' +
          '<div class="vd-drawer__section-title">DIMENSIONS</div>' +
          '<div class="vd-drawer__sizes" data-sizes></div>' +
        '</div>' +
      '</div>' +
      '<div class="vd-drawer__footer">' +
        '<button type="button" class="vd-drawer__add-btn btn btn--secondary" data-add-to-cart>' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
            '<circle cx="9" cy="21" r="1"></circle>' +
            '<circle cx="20" cy="21" r="1"></circle>' +
            '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>' +
          '</svg>' +
          '<span>Ajouter Au Panier</span>' +
        '</button>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    state.overlay = overlay;
    state.drawer = drawer;

    // EVENEMENTS
    overlay.addEventListener('click', function(e) {
      e.preventDefault();
      closeDrawer();
    });

    drawer.querySelector('.vd-drawer__close').addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
    });

    drawer.addEventListener('click', function(e) { e.stopPropagation(); });

    // Clic en dehors du drawer ferme le drawer
    document.addEventListener('click', function(e) {
      if (!state.isOpen) return;
      if (!drawer.contains(e.target) && !e.target.closest('[data-vd-open]')) {
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && state.isOpen) closeDrawer();
    });

    // MOBILE: DRAG TO CLOSE
    var handle = drawer.querySelector('[data-handle]');
    var header = drawer.querySelector('.vd-drawer__header');

    function onDragStart(e) {
      if (window.innerWidth >= 768) return;
      state.isDragging = true;
      state.dragStartY = e.type === 'mousedown' ? e.clientY : e.touches[0].clientY;
      state.currentTranslate = 0;
      drawer.style.transition = 'none';
    }

    function onDragMove(e) {
      if (!state.isDragging) return;
      var currentY = e.type === 'mousemove' ? e.clientY : e.touches[0].clientY;
      var diff = currentY - state.dragStartY;
      if (diff > 0) {
        state.currentTranslate = diff;
        drawer.style.transform = 'translateY(' + diff + 'px)';
      }
    }

    function onDragEnd() {
      if (!state.isDragging) return;
      state.isDragging = false;
      drawer.style.transition = '';
      if (state.currentTranslate > 100) {
        closeDrawer();
      } else {
        drawer.style.transform = '';
      }
      state.currentTranslate = 0;
    }

    [handle, header].forEach(function(el) {
      el.addEventListener('touchstart', onDragStart, { passive: true });
      el.addEventListener('mousedown', onDragStart);
    });

    document.addEventListener('touchmove', onDragMove, { passive: true });
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('touchend', onDragEnd);
    document.addEventListener('mouseup', onDragEnd);

    // ADD TO CART
    var addBtn = drawer.querySelector('[data-add-to-cart]');
    addBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (state.isAddingToCart || !state.productJson) return;

      var selected = getSelectedOptionsFromForm(state.productJson, state.formContext);
      var variant = findVariantByOptions(state.productJson, selected);

      if (!variant || !variant.available) {
        return;
      }

      state.isAddingToCart = true;
      addBtn.classList.add('btn--loading');
      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Erreur');
        closeDrawer();

        // Fermer aussi le Quick View si ouvert
        var quickViewModal = document.querySelector('quick-view-modal[open], quick-view-modal.active, quick-view-modal:not([hidden])');
        if (quickViewModal) {
          var closeBtn = quickViewModal.querySelector('.drawer__close-btn');
          if (closeBtn) closeBtn.click();
        }

        // Rafraichir le panier
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      })
      .catch(function(err) {
        console.error(err);
      })
      .finally(function() {
        state.isAddingToCart = false;
        addBtn.classList.remove('btn--loading');
        addBtn.disabled = false;
      });
    });
  }

  function renderShapes() {
    var section = state.drawer.querySelector('[data-shapes-section]');
    var container = state.drawer.querySelector('[data-shapes]');
    var title = state.drawer.querySelector('.vd-drawer__title');

    if (state.optShape === -1) {
      section.style.display = 'none';
      title.textContent = 'Choisir la taille';
      return;
    }

    section.style.display = 'block';
    title.textContent = 'Choisir la forme';

    var shapes = [];
    state.productJson.variants.forEach(function(v) {
      var shape = v.options[state.optShape];
      if (shape && shapes.indexOf(shape) === -1) {
        shapes.push(shape);
      }
    });

    container.innerHTML = '';

    shapes.forEach(function(shape) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vd-shape-card';
      btn.setAttribute('data-shape', shape);
      btn.innerHTML = '<div class="vd-shape-card__icon">' + getShapeSVG(shape) + '</div>' +
        '<span class="vd-shape-card__label">' + shape + '</span>';
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        setOptionValueInForm(state.productJson, state.optShape, shape, state.formContext);
        renderSizes(shape);
        highlightActive();
        updateSummary();
      });
      container.appendChild(btn);
    });
  }

  function renderSizes(selectedShape) {
    var container = state.drawer.querySelector('[data-sizes]');

    var items = [];
    state.productJson.variants.forEach(function(v) {
      if (state.optShape !== -1 && selectedShape) {
        if (normalize(v.options[state.optShape]) !== normalize(selectedShape)) return;
      }
      var size = v.options[state.optSize];
      if (!size) return;

      var existing = items.find(function(i) { return i.size === size; });
      if (!existing) {
        items.push({ size: size, price: v.price, compareAt: v.compare_at_price, available: v.available });
      } else if (v.price < existing.price) {
        existing.price = v.price;
        existing.compareAt = v.compare_at_price;
        existing.available = v.available;
      }
    });

    items.sort(function(a, b) {
      var na = (a.size.match(/\d+/g) || []).map(Number);
      var nb = (b.size.match(/\d+/g) || []).map(Number);
      for (var i = 0; i < Math.max(na.length, nb.length); i++) {
        if ((na[i] || 0) !== (nb[i] || 0)) return (na[i] || 0) - (nb[i] || 0);
      }
      return 0;
    });

    container.innerHTML = '';

    items.forEach(function(item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vd-size-row';
      btn.setAttribute('data-size', item.size);
      if (!item.available) {
        btn.disabled = true;
        btn.classList.add('is-disabled');
      }

      var discount = getDiscountPercent(item.price, item.compareAt);
      var stockText = item.available ? 'En Stock' : 'Epuise';
      var stockClass = item.available ? 'is-available' : 'is-unavailable';
      var dotColor = item.available ? '#22c55e' : '#ef4444';

      var html = '<span class="vd-size-row__left">' +
          '<span class="vd-size-row__size">' + item.size + '</span>' +
          '<span class="vd-size-row__stock ' + stockClass + '">' +
            '<span class="vd-size-row__dot" style="background:' + dotColor + '"></span>' +
            stockText +
          '</span>' +
        '</span>' +
        '<span class="vd-size-row__right">';

      if (discount > 0) {
        html += '<span class="vd-size-row__badge">-' + discount + '%</span>';
      }
      if (item.compareAt && item.compareAt > item.price) {
        html += '<span class="vd-size-row__compare">' + formatMoney(item.compareAt, state.moneyFormat) + '</span>';
      }
      html += '<span class="vd-size-row__price">' + formatMoney(item.price, state.moneyFormat) + '</span>' +
        '</span>';

      btn.innerHTML = html;

      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (btn.disabled) return;
        setOptionValueInForm(state.productJson, state.optSize, item.size, state.formContext);
        highlightActive();
        updateSummary();
      });

      container.appendChild(btn);
    });

    highlightActive();
  }

  function highlightActive() {
    var selected = getSelectedOptionsFromForm(state.productJson, state.formContext);
    var currentShape = state.optShape !== -1 ? selected[state.optShape] : '';
    var currentSize = state.optSize !== -1 ? selected[state.optSize] : '';

    state.drawer.querySelectorAll('[data-shape]').forEach(function(el) {
      el.classList.toggle('is-active', normalize(el.getAttribute('data-shape')) === normalize(currentShape));
    });

    state.drawer.querySelectorAll('[data-size]').forEach(function(el) {
      el.classList.toggle('is-active', normalize(el.getAttribute('data-size')) === normalize(currentSize));
    });
  }

  function updateSummary() {
    if (!state.summaryEl || !state.productJson) return;
    var selected = getSelectedOptionsFromForm(state.productJson, state.formContext);
    var shape = state.optShape !== -1 ? selected[state.optShape] : '';
    var size = state.optSize !== -1 ? selected[state.optSize] : '';
    var variant = findVariantByOptions(state.productJson, selected);
    var price = variant ? formatMoney(variant.price, state.moneyFormat) : '';
    var parts = [];
    if (shape) parts.push(shape);
    if (size) parts.push(size);
    state.summaryEl.textContent = parts.length ? parts.join(' \u00B7 ') + ' \u2014 ' + price : 'Choisir';
  }

  function buildUI() {
    renderShapes();
    var selected = getSelectedOptionsFromForm(state.productJson, state.formContext);
    var currentShape = state.optShape !== -1 ? selected[state.optShape] : null;
    if (state.optShape !== -1 && !currentShape) {
      var firstBtn = state.drawer.querySelector('[data-shape]');
      if (firstBtn) {
        currentShape = firstBtn.getAttribute('data-shape');
        setOptionValueInForm(state.productJson, state.optShape, currentShape, state.formContext);
      }
    }
    renderSizes(currentShape);
    highlightActive();
    updateSummary();
  }

  function initRoot(root) {
    if (root.getAttribute('data-vd-initialized') === 'true') return;
    root.setAttribute('data-vd-initialized', 'true');

    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var productJson;
    try { productJson = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var openBtn = root.querySelector('[data-vd-open]');
    var summaryEl = root.querySelector('[data-vd-summary]');
    if (!openBtn || !summaryEl) return;

    var optShape = findOptionIndex(productJson, ['forme', 'shape']);
    var optSize = findOptionIndex(productJson, ['taille', 'size', 'dimension']);

    console.log('VD V12: Options detectees', {
      options: productJson.options,
      optShape: optShape,
      optSize: optSize
    });

    if (optShape === -1 && optSize === -1) return;

    createDrawer();

    function getContext() {
      var quickView = root.closest('quick-view-modal');
      return quickView || root.closest('product-info') || document;
    }

    openBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Toggle: si déjà ouvert, fermer
      if (state.isOpen) {
        closeDrawer();
        return;
      }
      
      state.productJson = productJson;
      state.optShape = optShape;
      state.optSize = optSize;
      state.moneyFormat = (window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.moneyFormat) || root.getAttribute('data-money-format') || '{{amount}}\u20AC';
      state.summaryEl = summaryEl;
      state.formContext = getContext();
      buildUI();
      openDrawer();
    });

    // Init summary
    (function() {
      var context = getContext();
      var selected = [];
      productJson.options.forEach(function(optionName) {
        var checkedRadio = context.querySelector('input[type="radio"][data-option-name="' + optionName + '"]:checked');
        if (checkedRadio) { selected.push(checkedRadio.value); return; }
        var fieldset = context.querySelector('fieldset[data-option-name="' + optionName + '"]');
        if (fieldset) {
          var checkedInput = fieldset.querySelector('input[type="radio"]:checked');
          if (checkedInput) { selected.push(checkedInput.value); return; }
        }
        selected.push('');
      });

      var shape = optShape !== -1 ? selected[optShape] : '';
      var size = optSize !== -1 ? selected[optSize] : '';
      var variant = findVariantByOptions(productJson, selected);
      var mf = (window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.moneyFormat) || root.getAttribute('data-money-format') || '{{amount}}\u20AC';
      var price = variant ? formatMoney(variant.price, mf) : '';
      var parts = [];
      if (shape) parts.push(shape);
      if (size) parts.push(size);
      summaryEl.textContent = parts.length ? parts.join(' \u00B7 ') + ' \u2014 ' + price : 'Choisir';
    })();
  }

  function boot() {
    document.querySelectorAll('[data-variant-drawer-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  // QUICK VIEW SUPPORT
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.matches && node.matches('[data-variant-drawer-root]')) {
            initRoot(node);
          }
          var roots = node.querySelectorAll ? node.querySelectorAll('[data-variant-drawer-root]') : [];
          roots.forEach(initRoot);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('quickview:loaded', function() { setTimeout(boot, 100); });
  document.addEventListener('quick-view:open', function() { setTimeout(boot, 100); });

})(); 